import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Header from './Header.js';
import Navigator from './Navigator';
import Listings from './Listings';
import BottomNavigator from './BottomNavigator.js';

import './Home.css';

function Home({ state, setState }) {
    const { countryname } = useParams();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (countryname) {
            const filteredCountry = state.countries.find(country => country.dir === countryname);
            if (filteredCountry && filteredCountry.defaultdistrict) {
                setState(state => ({ ...state, selectedcountry: filteredCountry.id, selecteddistrict: filteredCountry.defaultdistrict }));
            }
        }
    }, [countryname, state.countries])

    return (
        <div className='home'>
            <Navigator state={state} setState={setState} />
            <Listings state={state} setState={setState} />
            <BottomNavigator state={state} setState={setState} />
        </div>
    )
}

export default Home;